
export let DatosGeneralesSAE = {
    showSpinnerLoading: false
}



// WEBPACK FOOTER //
// ./src/app/datos-generales-SAE.ts